export const environment = {
    production: true,
    hmr: false,
    apiUrl: 'https://wfw.amatis.dev/adminapi'
  };
  
